import React from 'react';
import styled from 'styled-components';
import Text from '@service-victoria/component-library/components/Text';
import Page from '@service-victoria/component-library/components/Page';
import { Button } from '@service-victoria/component-library/components/Button';
import Accordion from '@service-victoria/component-library/components/Accordion';
import Tabs, { TabItem } from '@service-victoria/component-library/components/Tabs';
import { useHistory } from 'react-router-dom';
import { constants, logger } from 'utils';
import bannerImg from 'assets/great-ocean-image.jpg';
import PartnerLogo from 'assets/VIC-DH-logo-black.jpg';
import * as Styled from './styled';
import { useWindowSize } from 'hooks';
import { app as appContext } from 'context';
import { ExternalLinks, PageConfig } from 'utils/constants';
import BeforeYouStart from './components/BeforeYouStart';

const disableBorderPermits = (process.env.REACT_APP_DISABLE_BORDER_PERMITS || '').trim() === 'true';

const items: TabItem[] = [
  {
    id: 'before-you-start',
    title: 'Before you start',
    component: <BeforeYouStart />
  },
  {
    id: 'faq',
    title: 'FAQs',
    component: (
      <>
        <Text.Link
          target='_blank'
          value='Frequently asked questions'
          href={PageConfig.LANDING_PAGE}
          showExtraLink
        />{' '}
        about the permit system for international travel to Victoria.
      </>
    )
  }
];

const PageWrapper = styled(Page)``;

// Todo - remove this comment
const Home: React.FC = () => {
  const history = useHistory();
  const windowSize = useWindowSize();
  const { currentState } = appContext.useAppContext();

  return (
    <PageWrapper
      headerProps={{
        fetchItemsFromAPI: true,
        showSideNav: true
      }}
      title={constants.Page.title}
      showFooter={true}
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}
      loading={false}
      error={undefined}
      opacityBetweenLoading={0}>
      <Styled.Wrapper>
        {!disableBorderPermits ? (
          <>
            <Styled.Header>
              <Styled.Description>Apply for permission to enter Victoria</Styled.Description>
              <Styled.Line />
              <Styled.Timer>
                <Styled.Icon />
                <Styled.TextHead>
                  This takes about
                  <span>5 mins</span>
                </Styled.TextHead>
              </Styled.Timer>
            </Styled.Header>
            <Styled.DoubleLine />
            <Styled.Body>
              {windowSize === 'mobile' ? <Accordion items={items} /> : <Tabs items={items} />}
            </Styled.Body>
            <Styled.ButtonWrapper>
              <Button
                data-testid='GetStarted-Button'
                buttonType='primary'
                onClick={() => {
                  logger.info(`Start transaction for ${currentState.transactionID}`, {
                    transactionID: currentState.transactionID
                  });
                  history.push(constants.Routes.Transaction);
                }}>
                Get started
              </Button>
            </Styled.ButtonWrapper>
            <Styled.Logos>
              {/* <Styled.VicLogo>
              A program of
              <img src={VicLogo} alt='vic-logo' />
            </Styled.VicLogo> */}
              <Styled.ParnershipLogo>
                In partnership with
                <img src={PartnerLogo} alt='parnership-logo' width='205' />
              </Styled.ParnershipLogo>
            </Styled.Logos>
          </>
        ) : (
          <Styled.DisabledPermits.Wrapper>
            <Styled.DisabledPermits.Content>
              <Text.Heading.H1 fontWeight='bold'>
                COVID-19 information for travellers
              </Text.Heading.H1>
              <Styled.Spacer16 />
              <Text.Body>
                From 6pm Friday 18 February 2022, you no longer need a COVID-19 Border Entry Permit
                to enter Victoria.
              </Text.Body>
              <Text.Body>
                Find more info about travelling to and from Victoria, including both interstate and
                international advice, visit{' '}
                <Text.Link href={ExternalLinks.BetterhealthCovidTravel}>
                  betterhealth.vic.gov.au
                </Text.Link>
                .
              </Text.Body>
            </Styled.DisabledPermits.Content>
            <Styled.DisabledPermits.Footer>
              <Styled.ParnershipLogo>
                A program of
                <img src={PartnerLogo} alt='parnership-logo' width='205' />
              </Styled.ParnershipLogo>
              <Styled.HomeButton>Home</Styled.HomeButton>
            </Styled.DisabledPermits.Footer>
          </Styled.DisabledPermits.Wrapper>
        )}
      </Styled.Wrapper>
    </PageWrapper>
  );
};

export default Home;
